import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { applyColorStyles } from "./utils/siteSettings";
import useAnalytics from "./hooks/useAnalytics";

// Apply saved colors on app load
applyColorStyles();

function LanguageDirectionHandler() {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const dir = i18nInstance.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = i18nInstance.language;
    // Apply Arabic font when RTL
    if (i18nInstance.language === 'ar') {
      document.documentElement.style.fontFamily = "'Noto Sans Arabic', 'Cairo', sans-serif";
    } else {
      document.documentElement.style.fontFamily = '';
    }
  }, [i18nInstance.language]);

  return null;
}

function AnalyticsTracker() {
  useAnalytics();
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LanguageDirectionHandler />
        <AnalyticsTracker />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
